/**
 * oddit-section-main-product
 * Interactive behaviors: Gallery thumbnails, flavor/size selectors,
 * frequency toggle, and accordions.
 */
;(function () {
  const section = document.querySelector('.oddit-section-main-product')
  if (!section) return

  /* ---- Gallery: Thumbnail click -> show main image ---- */
  const thumbnails = section.querySelectorAll('.oddit-section-main-product__thumbnail')
  const mainImages = section.querySelectorAll('.oddit-section-main-product__main-image')
  const slider = section.querySelector('.oddit-section-main-product__main-image-slider')

  function scrollThumbnailIntoView(index) {
    var thumbContainer = section.querySelector('.oddit-section-main-product__thumbnails')
    if (!thumbContainer || !thumbnails[index]) return
    var thumb = thumbnails[index]
    var isVertical = window.innerWidth >= 990
    var overlayBottomInset = 80

    var c = thumbContainer.getBoundingClientRect()
    var t = thumb.getBoundingClientRect()

    /* Only scroll the thumbnail strip — never scrollIntoView (it scrolls the page). */
    if (isVertical) {
      var visibleBottom = c.bottom - overlayBottomInset
      if (t.top < c.top) {
        thumbContainer.scrollTo({
          top: Math.max(0, thumbContainer.scrollTop + (t.top - c.top)),
          behavior: 'smooth',
        })
      } else if (t.bottom > visibleBottom) {
        thumbContainer.scrollTo({
          top: Math.max(0, thumbContainer.scrollTop + (t.bottom - visibleBottom)),
          behavior: 'smooth',
        })
      }
    } else {
      if (t.left < c.left) {
        thumbContainer.scrollTo({
          left: Math.max(0, thumbContainer.scrollLeft + (t.left - c.left)),
          behavior: 'smooth',
        })
      } else if (t.right > c.right) {
        thumbContainer.scrollTo({
          left: Math.max(0, thumbContainer.scrollLeft + (t.right - c.right)),
          behavior: 'smooth',
        })
      }
    }
  }

  function setActiveImage(index) {
    thumbnails.forEach(function (thumb, i) {
      thumb.classList.toggle('oddit-section-main-product__thumbnail--active', i === index)
    })
    // Desktop: show/hide
    mainImages.forEach(function (img, i) {
      img.classList.toggle('oddit-section-main-product__main-image--active', i === index)
    })
    // Mobile: scroll to image
    if (slider && window.innerWidth < 990) {
      var target = mainImages[index]
      if (target) {
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
      }
    }
    scrollThumbnailIntoView(index)
  }

  thumbnails.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      setActiveImage(i)
    })
  })

  /* Thumbnail arrow (desktop): next image + scroll thumbnails when needed */
  var thumbArrow = section.querySelector('.oddit-section-main-product__thumbnail-arrow')
  var thumbContainer = section.querySelector('.oddit-section-main-product__thumbnails')

  if (thumbArrow && thumbContainer) {
    thumbArrow.addEventListener('click', function () {
      var currentIndex = 0
      thumbnails.forEach(function (thumb, i) {
        if (thumb.classList.contains('oddit-section-main-product__thumbnail--active')) {
          currentIndex = i
        }
      })
      var nextIndex = currentIndex + 1

      // If already on the last thumbnail, reset to the first and scroll to top
      if (nextIndex >= thumbnails.length) {
        setActiveImage(0)
        thumbContainer.scrollTop = 0
        return
      }

      setActiveImage(nextIndex)

      // Scroll so the active thumbnail is visible above the arrow overlay
      var thumb = thumbnails[nextIndex]
      if (thumb) {
        var containerRect = thumbContainer.getBoundingClientRect()
        var thumbRect = thumb.getBoundingClientRect()
        // 80px accounts for the arrow overlay at the bottom
        if (thumbRect.bottom > containerRect.bottom - 80 || thumbRect.top < containerRect.top) {
          var scrollTarget = thumb.offsetTop - thumbContainer.offsetTop - containerRect.height + thumb.offsetHeight + 80
          thumbContainer.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' })
        }
      }
    })
  }

  /* Gallery arrows (mobile) */
  var galleryArrowRight = section.querySelector('.oddit-section-main-product__gallery-arrow--right')
  var galleryArrowLeft = section.querySelector('.oddit-section-main-product__gallery-arrow--left')

  function getVisibleSlideIndex() {
    if (!slider || !mainImages.length) return 0
    var sliderLeft = slider.scrollLeft
    var closest = 0
    var closestDist = Infinity
    mainImages.forEach(function (img, i) {
      var dist = Math.abs(img.offsetLeft - sliderLeft)
      if (dist < closestDist) {
        closestDist = dist
        closest = i
      }
    })
    return closest
  }

  function updateGalleryArrows(index) {
    if (galleryArrowLeft) {
      galleryArrowLeft.hidden = index === 0
    }
    if (galleryArrowRight) {
      galleryArrowRight.hidden = index >= mainImages.length - 1
    }
  }

  if (slider) {
    var scrollTimeout
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(function () {
        var index = getVisibleSlideIndex()
        thumbnails.forEach(function (thumb, i) {
          thumb.classList.toggle('oddit-section-main-product__thumbnail--active', i === index)
        })
        mainImages.forEach(function (img, i) {
          img.classList.toggle('oddit-section-main-product__main-image--active', i === index)
        })
        updateGalleryArrows(index)
        scrollThumbnailIntoView(index)
      }, 50)
    })
  }

  if (galleryArrowRight && slider) {
    galleryArrowRight.addEventListener('click', function () {
      var currentIndex = getVisibleSlideIndex()
      if (currentIndex < mainImages.length - 1) {
        var target = mainImages[currentIndex + 1]
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
      }
    })
  }

  if (galleryArrowLeft && slider) {
    galleryArrowLeft.addEventListener('click', function () {
      var currentIndex = getVisibleSlideIndex()
      if (currentIndex > 0) {
        var target = mainImages[currentIndex - 1]
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
      }
    })
  }

  // Initialize arrow visibility
  updateGalleryArrows(0)

  /* ---- Type / Flavor selector (cross-product family metafield) ---- */
  var familySelector = section.querySelector('[data-family-selector]')
  if (familySelector) {
    var currentTypeKey = familySelector.getAttribute('data-current-type-key') || ''
    var typeButtons = familySelector.querySelectorAll('.oddit-section-main-product__type-btn')
    var flavorItems = familySelector.querySelectorAll('.oddit-section-main-product__flavor-btn[data-family-type-key]')
    var flavorStep = familySelector.querySelector('[data-flavor-step]')

    function setActiveTypeByKey(newKey) {
      currentTypeKey = newKey || ''

      typeButtons.forEach(function (btn) {
        var key = btn.getAttribute('data-type-key') || ''
        var isActive = key === currentTypeKey
        btn.classList.toggle('oddit-section-main-product__type-btn--active', isActive)
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })

      flavorItems.forEach(function (el) {
        var key = el.getAttribute('data-family-type-key') || ''
        el.style.display = key === currentTypeKey ? '' : 'none'
      })
    }

    typeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveTypeByKey(btn.getAttribute('data-type-key') || '')

        if (flavorStep) {
          flavorStep.classList.remove('oddit-section-main-product__option-group--locked')
        }
      })
    })

    setActiveTypeByKey(currentTypeKey)
  }

  /* ---- Frequency / Subscription selector ---- */
  var form = section.querySelector('.oddit-section-main-product__form')
  var sellingPlanInput = form ? form.querySelector('[data-selling-plan]') : null
  var freqCards = section.querySelectorAll('.oddit-section-main-product__freq-card')
  var freqHiddenInput = section.querySelector('[data-selling-plan-frequency]')
  var priceDisplay = section.querySelector('[data-product-price]')
  var addToCartPrice = section.querySelector('[data-add-to-cart-price]')
  var servingPriceEls = section.querySelectorAll('.oddit-section-main-product__per-serving-amount')
  var frequencyLabel = section.querySelector('[data-frequency-label]')

  function updateSubscriptionState(isSubscription) {
    if (form) {
      form.classList.toggle('is-subscription', isSubscription)
    }

    if (frequencyLabel) {
      if (isSubscription) {
        var discount = frequencyLabel.getAttribute('data-discount')
        var text = 'Subscribe & Save'
        if (discount) text += '\u00A0' + discount + '%'
        frequencyLabel.textContent = text
      } else {
        frequencyLabel.textContent = 'One-Time Purchase'
      }
    }

    // Update selling_plan hidden input
    if (sellingPlanInput) {
      if (isSubscription && freqHiddenInput) {
        sellingPlanInput.value = freqHiddenInput.value
      } else {
        sellingPlanInput.value = ''
      }
    }

    // Update per-serving prices on size cards
    servingPriceEls.forEach(function (el) {
      var oneTimePrice = el.getAttribute('data-price-onetime')
      var subscriptionPrice = el.getAttribute('data-price-subscription') || oneTimePrice
      if (oneTimePrice) {
        el.textContent = isSubscription ? subscriptionPrice : oneTimePrice
      }
    })

    // Update main price display
    var subscribePrice = section.querySelector('[data-subscribe-price]')
    var onetimePrice = section.querySelector('[data-onetime-price]')
    if (priceDisplay) {
      if (isSubscription && subscribePrice) {
        priceDisplay.textContent = subscribePrice.textContent
      } else if (onetimePrice) {
        priceDisplay.textContent = onetimePrice.textContent
      }
    }

    // Update ATC button price
    if (addToCartPrice) {
      if (isSubscription && subscribePrice) {
        addToCartPrice.textContent = subscribePrice.textContent
      } else if (onetimePrice) {
        addToCartPrice.textContent = onetimePrice.textContent
      }
    }
  }

  freqCards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-freq-dropdown]') || e.target.closest('[data-freq-dropdown-list]')) {
        return
      }
      freqCards.forEach(function (c) {
        c.classList.remove('oddit-section-main-product__freq-card--active')
        var radio = c.querySelector('.oddit-section-main-product__radio')
        if (radio) radio.classList.remove('oddit-section-main-product__radio--selected')
        var details = c.querySelector('.oddit-section-main-product__freq-details')
        if (details) details.style.display = 'none'
      })
      card.classList.add('oddit-section-main-product__freq-card--active')
      var radio = card.querySelector('.oddit-section-main-product__radio')
      if (radio) radio.classList.add('oddit-section-main-product__radio--selected')
      var details = card.querySelector('.oddit-section-main-product__freq-details')
      if (details) details.style.display = ''

      var isSubscription = card.getAttribute('data-frequency') === 'subscribe'
      updateSubscriptionState(isSubscription)
    })
  })

  /* ---- Custom frequency dropdown ---- */
  var freqDropdownTrigger = section.querySelector('[data-freq-dropdown]')
  var freqDropdownList = section.querySelector('[data-freq-dropdown-list]')
  var freqDropdownLabel = section.querySelector('[data-freq-dropdown-label]')
  var freqDropdownItems = section.querySelectorAll('.oddit-section-main-product__freq-dropdown-item')

  if (freqDropdownTrigger && freqDropdownList) {
    freqDropdownTrigger.addEventListener('click', function (e) {
      e.stopPropagation()
      // Don't toggle if clicking a dropdown item (handled separately)
      if (e.target.closest('.oddit-section-main-product__freq-dropdown-item')) return
      var isOpen = !freqDropdownList.hidden
      freqDropdownList.hidden = isOpen
      freqDropdownTrigger.classList.toggle('is-open', !isOpen)
    })

    freqDropdownItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation()
        var planId = item.getAttribute('data-freq-plan-id')
        var display = item.getAttribute('data-freq-display')
        var badge = item.getAttribute('data-freq-badge')

        // Update hidden input
        if (freqHiddenInput) freqHiddenInput.value = planId
        if (sellingPlanInput && form && form.classList.contains('is-subscription')) {
          sellingPlanInput.value = planId
        }

        // Update label
        if (freqDropdownLabel) {
          var html = '<span>' + display + '</span>'
          if (badge) {
            html += ' <span class="oddit-section-main-product__freq-tag">' + badge + '</span>'
          }
          freqDropdownLabel.innerHTML = html
        }

        // Update active state
        freqDropdownItems.forEach(function (i) {
          i.classList.remove('oddit-section-main-product__freq-dropdown-item--active')
        })
        item.classList.add('oddit-section-main-product__freq-dropdown-item--active')

        // Close dropdown
        freqDropdownList.hidden = true
        freqDropdownTrigger.classList.remove('is-open')
      })
    })

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!freqDropdownTrigger.contains(e.target)) {
        freqDropdownList.hidden = true
        freqDropdownTrigger.classList.remove('is-open')
      }
    })
  }

  // Initialize: subscription is default active if subscribe card is active
  var activeFreqCard = section.querySelector('.oddit-section-main-product__freq-card--active')
  if (activeFreqCard && activeFreqCard.getAttribute('data-frequency') === 'subscribe') {
    updateSubscriptionState(true)
  }

  /* ---- AJAX Add to Cart ---- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()
      e.stopPropagation()

      var atcBtn = form.querySelector('[data-add-to-cart]')
      if (!atcBtn || atcBtn.disabled) return

      var variantInput = form.querySelector('[name="id"]')
      var sellingPlanInput = form.querySelector('[name="selling_plan"]')
      var variantId = variantInput ? Number(variantInput.value) : null
      if (!variantId) return

      var sellingPlanId = sellingPlanInput && sellingPlanInput.value ? Number(sellingPlanInput.value) : null

      atcBtn.style.pointerEvents = 'none'
      atcBtn.style.opacity = '0.5'
      var originalHTML = atcBtn.innerHTML
      atcBtn.innerHTML = 'Adding\u2026'

      var body = { id: variantId, quantity: 1 }
      if (sellingPlanId) {
        body.selling_plan = sellingPlanId
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed: ' + res.status)
          return res.json()
        })
        .then(function () {
          if (window.OdditCartDrawer) {
            window.OdditCartDrawer.refreshCart().then(function () {
              window.OdditCartDrawer.open()
            })
          }
        })
        .catch(function (err) {
          console.error('[oddit-main-product] ATC error:', err)
        })
        .finally(function () {
          atcBtn.style.pointerEvents = ''
          atcBtn.style.opacity = ''
          atcBtn.innerHTML = originalHTML
        })
    })
  }

  /* ---- Cross-sell: add linked product via Oddit Cart (bind all CTAs; PDP may have multiple section roots in editor) ---- */
  document.querySelectorAll('.oddit-section-main-product [data-cross-sell-add]').forEach(function (crossSellAdd) {
    crossSellAdd.addEventListener('click', function (e) {
      e.preventDefault()

      var variantAttr = crossSellAdd.getAttribute('data-variant-id')
      if (!variantAttr) return
      var variantId = Number(variantAttr)
      if (!variantId) return

      crossSellAdd.style.pointerEvents = 'none'
      crossSellAdd.style.opacity = '0.5'
      var crossOriginalHTML = crossSellAdd.innerHTML
      crossSellAdd.innerHTML = 'Adding\u2026'

      function crossSellReset() {
        crossSellAdd.style.pointerEvents = ''
        crossSellAdd.style.opacity = ''
        crossSellAdd.innerHTML = crossOriginalHTML
      }

      if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
        window.OdditCartDrawer.addToCart(variantId, 1, {})
          .catch(function (err) {
            console.error('[oddit-main-product] cross-sell addToCart error:', err)
          })
          .finally(crossSellReset)
        return
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cross-sell add failed: ' + res.status)
          return res.json()
        })
        .then(function () {
          if (window.OdditCartDrawer) {
            return window.OdditCartDrawer.refreshCart().then(function () {
              window.OdditCartDrawer.open()
            })
          }
        })
        .catch(function (err) {
          console.error('[oddit-main-product] cross-sell ATC error:', err)
        })
        .finally(function () {
          crossSellReset()
        })
    })
  })

  /* ---- Estimated delivery: geolocation prompt; label + today + lead days (theme setting) ---- */
  function formatEstimatedDeliveryDate(leadDaysRaw) {
    var n = parseInt(leadDaysRaw, 10)
    if (isNaN(n) || n < 1) n = 5
    var d = new Date()
    d.setHours(0, 0, 0, 0)
    d.setDate(d.getDate() + n)
    return d.toLocaleDateString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
  }

  var estDeliveryEl = section.querySelector('[data-estimated-delivery]')
  if (estDeliveryEl) {
    var shippingItem = estDeliveryEl.closest('.oddit-section-main-product__shipping-item')
    if (shippingItem) {
      shippingItem.style.display = 'none'
      if (navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === 'function') {
        navigator.geolocation.getCurrentPosition(
          function () {
            var label = estDeliveryEl.getAttribute('data-estimated-delivery-label') || ''
            var lead = estDeliveryEl.getAttribute('data-estimated-delivery-lead-days')
            var dateStr = formatEstimatedDeliveryDate(lead)
            estDeliveryEl.textContent = label.trim() ? label.trim() + ' ' + dateStr : dateStr
            shippingItem.style.removeProperty('display')
          },
          function () {
            /* User denied, timeout, or API unavailable — keep hidden */
          },
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 0 }
        )
      }
    }
  }

  /* ---- Accordions ---- */
  var accordions = section.querySelectorAll('[data-accordion]')
  accordions.forEach(function (accordion) {
    var header = accordion.querySelector('.oddit-section-main-product__accordion-header')
    var content = accordion.querySelector('.oddit-section-main-product__accordion-content')
    if (!header || !content) return

    header.addEventListener('click', function () {
      var isOpen = accordion.hasAttribute('data-open')
      if (isOpen) {
        accordion.removeAttribute('data-open')
        header.setAttribute('aria-expanded', 'false')
        content.hidden = true
      } else {
        accordion.setAttribute('data-open', '')
        header.setAttribute('aria-expanded', 'true')
        content.hidden = false
      }
    })
  })
})()
